module.exports = __webpack_public_path__ + "img/384.676ce488.png";